export const formatAccountNumber = (accountNumber: string): string => {
    const cleanAccountNumber: string = accountNumber.replace(' ', '')

    return cleanAccountNumber.replace(/(\d{2})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})/, '$1 $2 $3 $4 $5 $6 $7')
}